import React, {useRef, useState} from "react";
import {makeStyles, useTheme} from '@material-ui/core/styles';
import {AppBar, Dialog, DialogActions, DialogContent} from "@material-ui/core";
import {useSelector} from "../../store";
import Button from "../../lib/appfuse-react/component/Button";
import Space from "../../lib/appfuse-react/component/Space";
import Typography from "@material-ui/core/Typography";
import SearchField from "../../component/SearchField";
import Expander from "../../lib/appfuse-react/component/Expander";
import Toolbar from "../../component/Toolbar";
import {selectTitle} from "../../reducer/app/appReducer";
import i18n from "../../lib/appfuse-react/core/i18n";
import {selectContentTypes} from "../../reducer/content/contentTypeReducer";
import env from "../../lib/appfuse-react/core/env";
import lang from "../../lib/appfuse-react/core/lang";
import Box from "../../lib/appfuse-react/component/Box";
import useRouter from "../../lib/appfuse-react/hook/useRouter";
import {useHistory, useRouteMatch} from "react-router-dom";
import Image from "../../lib/appfuse-react/component/Image";

const initialContext = {
    workspace: undefined
}

const ExplorerContext = React.createContext(initialContext);

const useStyles = makeStyles((theme) => ({
    appBar: {
        zIndex: theme.zIndex.drawer + 100,
        backgroundColor: theme.brand.appbar?.backgroundColor,
        color: theme.brand.appbar?.color,
    },
}));

function Explorer(props) {
    const theme = useTheme();
    const router = useRouter();
    const history = useHistory();
    const backgroundImage = router.resolve(theme.brand.backgroundImage);
    const classes = useStyles({backgroundImage});
    const [keyword, setKeyword] = useState(null);
    const title = useSelector(selectTitle);
    const { path } = useRouteMatch();
    const contentTypes = useSelector(selectContentTypes);
    const responsive = env.responsive;
    const workspaceRef = useRef();
    const workspace = workspaceRef?.current;
    const [openDialog, setOpenDialog] = useState();

    const handleSearch = event => {
        const keyword = event.value;
        setKeyword(keyword);
    }

    window.document.title = i18n.translate(title);

    const settings = env.get('app');
    const stageInfo = env.appStage.toUpperCase() === 'PROD' ? null : env.appStage;
    const versionInfo = env.appVersion + `${stageInfo ? '@' + stageInfo: ''}`;
    return (
        <Box className="app-explorer" fullHeight fullWidth overflow="hidden" display="flex" flexDirection="column">
            <AppBar position="static" className={classes.appBar}>
                <Toolbar>
                    <Image value={theme.brand.logo} onClick={()=> history.push('/')} height={32} title={versionInfo}/>
                    <Space spacing={1} />
                    <Typography variant="h5" noWrap>
                        {i18n.translate(title)}
                        <Space spacing={1} />
                        {stageInfo ? <Typography variant="body2" display="inline">{versionInfo}</Typography> : null}
                    </Typography>
                    <Box display={lang.isFalse(settings.search) ? 'none' : 'initial'}>
                        <SearchField label="Search" value={keyword} onChange={handleSearch} />
                    </Box>
                    <Expander />
                    <Button text='Privacy and Personal Information Statement' variant='text' color='inherit' onClick={() => setOpenDialog(true)}/>
                    <Button text="Login" variant="text" color="inherit" onClick={() => history.push('/logon')} />
                    <Box display={lang.isFalse(settings.registration) ? 'none' : 'initial'}>
                        <Button text="Register" variant="text" color="inherit" onClick={() => history.push('/registration')}/>
                    </Box>
                </Toolbar>
            </AppBar>
            <Box fullHeight fullWidth  overflow="auto" backgroundImage={backgroundImage}>
                <Box ref={workspaceRef} fullHeight fullWidth overflow="hidden"  minWidth={`${responsive.minWidth}px`}>
                    <ExplorerContext.Provider value={{workspace}}>
                        {props.children}
                    </ExplorerContext.Provider>
                </Box>
            </Box>
            <PrivacyAndPersonalInformationStatementDialog open={openDialog} onClose={() => setOpenDialog(false)}/>
        </Box>
    )
}

function PrivacyAndPersonalInformationStatementDialog(props) {
    const {open, onClose} = props;

    return (
        <Dialog open={open} maxWidth='lg' fullWidth onClose={onClose}>
            <DialogContent>
                <Box display='flex' flexDirection='column' gap={2}>
                    <Typography style={{whiteSpace: 'pre-wrap'}}>
                        {'非常歡迎您光臨「慈悅國際服務網站」（以下簡稱本網站），為了讓您能夠安心使用本網站的各項服務與資訊，特此向您說明本網站的隱私權保護政策，以保障您的權益，請您詳閱下列內容：'}
                    </Typography>
                    <Typography style={{fontWeight: 'bold'}}>
                        {'一、隱私權保護政策的適用範圍'}
                    </Typography>
                    <Box marginLeft={4}>
                        <Typography>
                            {'隱私權保護政策內容，包括本網站如何處理在您使用網站服務時收集到的公司、個人識別資料。隱私權保護政策不適用於本網站以外的相關連結網站，也不適用於非本網站所委託或、授權、參與管理的人員。'}
                        </Typography>
                    </Box>
                    <Typography style={{fontWeight: 'bold'}}>
                        {'二、個人資料的蒐集、處理及利用方式'}
                    </Typography>
                    <Box display='flex' flexDirection='column' gap={2} marginLeft={4}>
                        <Typography style={{whiteSpace: 'pre-wrap'}}>
                            {'歡迎您參加由慈悅國際股份有限公司（以下簡稱本公司）之評鑑業務申請，當您造訪本網站或使用本網站所提供之功能服務時，我們將視該服務功能性質，請您提供必要的個人資料，並在該特定目的範圍內處理及利用您的個人資料；非經您書面同意，本網站不會將個人資料用於其他用途。\n\n' +
                            '本網站在您註冊服務信箱等互動性功能時，會保留您所提供的個人名稱、姓名、電子郵件地址、聯絡方式及使用時間等。\n\n' +
                            '於一般瀏覽時，伺服器會自行記錄相關行徑，包括您使用連線設備的IP位址、使用時間、使用的瀏覽器、瀏覽及點選資料記錄等，做為我們增進網站服務的參考依據，此記錄為內部應用，決不對外公佈。\n\n' +
                            '為提供精確的服務，我們會將收集的問卷調查內容進行統計與分析，分析結果之統計數據或說明文字呈現，除供內部研究外，我們會視需要公佈統計數據及說明文字，但不涉及特定個人之資料。\n\n' +
                            '為了能提供您完善的服務並幫助您瞭解本公司如何蒐集、使用及保護您的個人資訊，謹依《個人資料保護法》第8條第1項之規定，向您告知下列事項，請您撥冗閱讀下列各項內容。\n\n' +
                            '(一)蒐集之目的：'}
                        </Typography>
                        <Box marginLeft={4}>
                            <Typography>
                                {'本公司為聯繫及辦理與您有關的評鑑相關作業，在提供服務之必要範圍內，取得您的公司、個人資料。使用的範圍包括會員服務、評鑑申請流程及活動訊息通知、活動報名等用途。您並同意本公司以您所提供的個人資料確認您的身份或與您進行連絡。'}
                            </Typography>
                        </Box>
                        <Typography>
                            {'(二)個人資料之類別：'}
                        </Typography>
                        <Box marginLeft={4}>
                            <Typography>
                                {'依前項所述之事項，需要提供以下個人資料：姓名、身分字號、服務單位、職稱、聯絡方式(電話、通訊地址及e-mail)等及其他可以直接或間接方式識別該個人之資料。'}
                            </Typography>
                        </Box>
                        <Typography>
                            {'(三)個人資料使用期間、地區、對象及利用方式：'}
                        </Typography>
                        <Box marginLeft={4}>
                            <Typography style={{whiteSpace: 'pre-wrap'}}>
                                {'1.當您同意本公司使用您的個人資料時，其使用期間自您註冊網站當日起至下列日期止：\n\n' +
                                '    (1)您退出或不再申請本公司之評鑑，並請求本公司停止使用您的個人資料之日。\n\n' +
                                '    (2)其他依法須保存之期限已屆滿期。\n\n' +
                                '2.地區：您的個人資料將僅被利用在台灣、金門、澎湖、馬祖地區。\n\n' +
                                '3.對象：對於您所提供之個人資料，本公司將於提供您相關的評鑑申請服務的範圍內予以利用，並採取適當之安全措施予以保護。\n\n' +
                                '4.使用方式：您的個人資料僅在法令許可及您的同意的範圍之下，於您所同意之期間內，以電子檔或紙本形式存於本公司，並提供予本公司於特定目的範圍內予以處理與使用，本公司並會採取適當之安全措施予以保護。'}
                            </Typography>
                        </Box>
                        <Typography>
                            {'(四)立書人之權益：'}
                        </Typography>
                        <Box marginLeft={4}>
                            <Typography style={{whiteSpace: 'pre-wrap'}}>
                                {'當本公司使用您的個人資料，您可依據個人資料保護法第3條，向本公司請求辦理下列權益事項：\n\n' +
                                    '1. 查詢或請求閱覽。\n\n' +
                                    '2. 製給複製本。\n\n' +
                                    '3. 補充或更正。\n\n' +
                                    '4. 停止蒐集、處理及利用。\n\n' +
                                    '5. 刪除。\n\n' +
                                    '當本公司保有您的個人資料時，基於我國「個人資料保護法」之規定。您可以透過書面或其他具體方式行使上述權益，除非有符合「個人資料保護法」與其他相關法律規定之事由外，本公司不會拒絕。\n\n'}
                            </Typography>
                        </Box>
                        <Typography>
                            {'(五)注意事項：您可自由選擇是否提供本公司您的個人資料，若您所提供之個人資料不完整時，本會可能無法提供您完善的評鑑服務。\n'}
                        </Typography>
                    </Box>
                    <Typography style={{fontWeight: 'bold'}}>
                        {'三、資料之保護'}
                    </Typography>
                    <Box marginLeft={4}>
                        <Typography style={{whiteSpace: 'pre-wrap'}}>
                            {'本網站主機均設有防火牆、防毒系統等相關的各項資訊安全設備及必要的安全防護措施，加以保護網站及您的個人資料採用嚴格的保護措施，只由經過授權的人員才能接觸您的公司、個人資料，相關處理人員皆簽有保密合約，如有違反保密義務者，將會受到相關的法律處分。\n' +
                                '如因業務需要有必要委託其他單位提供服務時，本網站亦會嚴格要求其遵守保密義務，並且採取必要檢查程序以確定其將確實遵守。\n'}
                        </Typography>
                    </Box>
                    <Typography style={{fontWeight: 'bold'}}>
                        {'四、網站對外的相關連結'}
                    </Typography>
                    <Box marginLeft={4}>
                        <Typography style={{whiteSpace: 'pre-wrap'}}>
                            {'本網站的網頁將提供慈悅官方網站的網路連結，自動更新貴公司通過廠商資訊、產品資訊以利消費者、上下游廠商購買貴公司通過評鑑產品或進行合作洽談。\n'}
                        </Typography>
                    </Box>
                    <Typography style={{fontWeight: 'bold'}}>
                        {'五、與第三人共用個人資料之政策'}
                    </Typography>
                    <Box marginLeft={4}>
                        <Typography style={{whiteSpace: 'pre-wrap'}}>
                            {'本網站絕不會提供、交換、出租或出售任何您的個人資料給其他個人、團體、私人企業或公務機關，但有法律依據或合約義務者，不在此限。\n\n' +
                                '前項但書之情形包括不限於：\n' +
                                '• 經由您書面同意。\n' +
                                '• 法律明文規定。\n' +
                                '• 為免除您生命、身體、自由或財產上之危險。\n' +
                                '• 與公務機關或學術研究機構合作，基於公共利益為統計或學術研究有必要，且資料經過提供者處理或蒐集著依其揭露方式無從識別特定之當事人。\n' +
                                '• 當您在網站的行為，違反服務條款或可能損害或妨礙網站與其他使用者權益或導致任何人遭受損害時，經網站管理單位研析揭露您的個人資料是為了辨識、聯絡或採取法律行動所必要者。\n' +
                                '• 有利於您的權益。\n' +
                                '• 本網站委託廠商協助蒐集、處理或利用您的個人資料時，將對委外廠商或個人善盡監督管理之責。\n'}
                        </Typography>
                    </Box>
                    <Typography style={{fontWeight: 'bold'}}>
                        {'六、Cookie之使用'}
                    </Typography>
                    <Box marginLeft={4}>
                        <Typography style={{whiteSpace: 'pre-wrap'}}>
                            {'為了提供您最佳的服務，本網站會在您的電腦中放置並取用我們的Cookie，若您不願接受Cookie的寫入，您可在您使用的瀏覽器功能項中設定隱私權等級為高，即可拒絕Cookie的寫入，但可能會導至網站某些功能無法正常執行 。\n'}
                        </Typography>
                    </Box>
                    <Typography style={{fontWeight: 'bold'}}>
                        {'七、隱私權保護政策之修正'}
                    </Typography>
                    <Box marginLeft={4}>
                        <Typography style={{whiteSpace: 'pre-wrap'}}>
                            {'本網站隱私權保護政策將因應需求隨時進行修正，修正後的條款將刊登於網站上。\n'}
                        </Typography>
                    </Box>
                    <Typography style={{fontWeight: 'bold'}}>
                        {'八、其他權益：'}
                    </Typography>
                    <Box marginLeft={4}>
                        <Typography style={{whiteSpace: 'pre-wrap'}}>
                            {'• 如何讀取、更新和刪除您及公司資料？\n\n'}
                        </Typography>
                        <Box marginLeft={4}>
                            <Typography>
                                {'當您在慈悅國際評鑑服務網站註冊為為會員後，您可以隨時利用您的會員帳號和密碼修改您的公司資料。如果您忘記密碼，只要按下忘記密碼按鍵，我們將會把新密碼提供給您。若想要停止您的公司評鑑業務時，可隨時由網站提出終止申請，慈悅將於收件後刪除。\n'}
                            </Typography>
                        </Box>
                    </Box>
                    <Box marginLeft={4}>
                        <Typography style={{whiteSpace: 'pre-wrap'}}>
                            {'• 對於您個人資料的安全防範措施？\n\n'}
                        </Typography>
                        <Box marginLeft={4}>
                            <Typography>
                                {'由於網際網路資料的傳輸不能保證百分之百的安全。因此，儘管慈悅評鑑服務網站保護您的個人資料安全，也無法確信或保證您傳送給我們的，或接收從我們的服務傳送出資料的安全，並且請您風險自擔。一旦收到您傳送的資料，我們將盡力以合理之技術及程序，保障您所有個人資料之安全。\n'}
                            </Typography>
                        </Box>
                    </Box>
                    <Box marginLeft={4}>
                        <Typography style={{whiteSpace: 'pre-wrap'}}>
                            {'• 網站帳號及密碼的保管措施？\n\n'}
                        </Typography>
                        <Box marginLeft={4} >
                            <Typography style={{whiteSpace: 'pre-wrap'}}>
                                {'1.\t您註冊會員所設定的會員帳號及個人密碼皆應視為機密，您應該負擔保管責任。任何依照系統規定方法輸入會員帳號及密碼與登入資料一致時，無論是否由您本人輸入，均將視為會員本人所使用，且利用該帳號及密碼所進行的一切活動視為您的行為，由您自行負責。\n\n'}
                            </Typography>
                            <Typography style={{whiteSpace: 'pre-wrap'}}>
                                {'2.\t您同意應妥善保管上述帳號及個人密碼等機密訊息，不得將該機密資訊轉借、讓與或以任何方式提供予第三人或使第三人知悉。且每次連線完畢，均應執行登出以結束您的帳號使用。\n\n'}
                            </Typography>
                            <Typography>
                                {'3.\t如因您的帳號及密碼發生盜用、不當使用或其他無法識別是否為本人親自始用者，或因故意或重大過失致未盡保管之責所生之損害，由您自行負責，本公司不負擔任何賠償或補償責任。\n\n'}
                            </Typography>
                        </Box>
                    </Box>
                    <Box marginLeft={4}>
                        <Typography style={{whiteSpace: 'pre-wrap'}}>
                            {'• 關於線上隱私我還應該知道甚麼？\n\n'}
                        </Typography>
                        <Box marginLeft={4}>
                            <Typography>
                                {'請牢記，無論何時您自願於線上透露個人資料，該資料均可能會被他人蒐集和使用。總之，如果您於線上公佈可被公眾讀取的個人資料時，您可能會收到其他團體主動提供的郵件。基本上，您的密碼或任何註冊帳戶資料的保密性必須由您單獨負責，請小心並保管您的註冊資料。\n'}
                            </Typography>
                        </Box>
                    </Box>
                    <Box marginLeft={4}>
                        <Typography style={{whiteSpace: 'pre-wrap'}}>
                            {'• 您瞭解本公司若查證您的會員帳號有發生本公司活動規範之外、不合法、影響他人權益、或舞弊操作等行為者，本公司擁有隨時停止或禁止使用該會員帳號之權利。？\n\n'}
                        </Typography>
                        <Box marginLeft={4}>
                            <Typography>
                                {'請注意，如您刪除會員帳號或遭停止或禁止使用會員帳號者時，系統將即刻刪除與該帳號關聯之所有活動通知，恕不另行通知。本公司對該會員或任何第三人均不承擔責任。\n'}
                            </Typography>
                        </Box>
                    </Box>
                    <Typography style={{alignSelf : 'center'}}>
                        {'Copyright(C) 2022慈悅國際股份有限公司. All Right Reserved. 著作權聲明'}
                    </Typography>
                </Box>
            </DialogContent>
            <DialogActions>
                <Box>
                    <Expander />
                    <Button text="Close" variant="contained" color="primary" onClick={onClose}/>
                </Box>
            </DialogActions>
        </Dialog>
    )
}




const withExplorer = WrappedComponent => (props) => {
    return (
        <Explorer>
            <WrappedComponent {...props} />
        </Explorer>
    );
};

export default Explorer;

export { withExplorer, ExplorerContext };